import { render, staticRenderFns } from "./sc-categories.vue?vue&type=template&id=6bf73e8e&scoped=true&"
import script from "./sc-categories.vue?vue&type=script&lang=js&"
export * from "./sc-categories.vue?vue&type=script&lang=js&"
import style0 from "./sc-categories.vue?vue&type=style&index=0&id=6bf73e8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf73e8e",
  null
  
)

export default component.exports